<claas-breadcrumb
  [productSeriesName]="$safeNavigationMigration(productSeries()?.Name)"
  [productName]="$safeNavigationMigration(product()?.Name)"
></claas-breadcrumb>

<div class="compare-headline-container">
  <h1 class="compare-title font-4xl">
    {{ "features.product-comparison.headline" | translate }}
  </h1>
</div>

<section class="compare-container">
  <nav class="tabs" mat-tab-nav-bar [tabPanel]="tabPanel">
    <a
      mat-tab-link
      [routerLink]="[
        argumentsTabActive()
          ? './'
          : `../../../../arguments/${this.productID()}/comparison/${this.competitorID()}`,
      ]"
      routerLinkActive
      [active]="argumentsTabActive()"
    >
      Arguments
    </a>

    <a
      mat-tab-link
      [routerLink]="[
        techDataTabActive()
          ? './'
          : `../../../../tech-data//${this.productID()}/comparison/${this.competitorID()}`,
      ]"
      routerLinkActive
      [active]="techDataTabActive()"
      >Tech Data</a
    >
  </nav>

  <div class="comparison">
    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </div>
</section>
